import { render, staticRenderFns } from "./config018-a-newtrend.vue?vue&type=template&id=ceba216c&"
import script from "./config018-a-newtrend.vue?vue&type=script&lang=js&"
export * from "./config018-a-newtrend.vue?vue&type=script&lang=js&"
import style0 from "./config018-a-newtrend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports